export const LOGO_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_1eed6f07-e2b5-4fe8-93d4-2c7d71a92930/artifacts/yczbfy13_logo.webp";

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about-us" },
  { label: "Services", to: "/services" },
  { label: "Clients", to: "/clients" },
  { label: "Contact Us", to: "/contact-us" },
];

export const CONTACT_INFO = {
  phone: "+91 98491 56375",
  email: "info@mithrajobs.com",
  address:
    "#501, Level 5, Plot No: 57/99 & 50/109, Survey No: 78, Patrika Nagar, Madhapur, HUDA Techno Enclave, HITEC City, Hyderabad, Telangana 500081",
  hours: "Monday – Saturday, 9:30 AM – 6:30 PM",
  linkedin: "#",
};

export const SERVICES_SHORT = [
  {
    title: "Teacher Recruitment",
    description: "Helping schools identify suitable teaching professionals for their vacancies.",
    icon: "ChalkboardTeacher",
  },
  {
    title: "Candidate Screening",
    description: "Reviewing candidates against the requirements provided by schools.",
    icon: "MagnifyingGlass",
  },
  {
    title: "School Staffing Solutions",
    description: "Supporting schools with their ongoing teacher recruitment requirements.",
    icon: "Buildings",
  },
  {
    title: "Recruitment Support",
    description: "Helping coordinate the recruitment journey from requirement to candidate selection.",
    icon: "Handshake",
  },
];

export const SERVICES_DETAILED = [
  {
    title: "Teacher Recruitment",
    description:
      "We help schools identify suitable teachers for open positions, working closely with you to understand the role before beginning the search.",
    tagline: "Matching schools with teaching professionals suited to the role.",
    icon: "ChalkboardTeacher",
  },
  {
    title: "Candidate Sourcing",
    description:
      "We identify potential teaching candidates based on the requirements shared by the school, including subject, experience and grade level.",
    tagline: "A focused search built around your requirement.",
    icon: "MagnifyingGlass",
  },
  {
    title: "Candidate Screening",
    description: "Candidate profiles are reviewed against the requirements provided by the school, such as:",
    points: ["Subject", "Qualification", "Teaching Experience", "Grade Level", "Curriculum Experience", "Relevant Skills"],
    tagline: "Reviewed against what your school actually needs.",
    icon: "ClipboardText",
  },
  {
    title: "Shortlisting",
    description:
      "Suitable candidates are shortlisted for consideration by the school, so you can focus on the profiles most relevant to your requirement.",
    tagline: "A focused shortlist, not an open inbox.",
    icon: "ListChecks",
  },
  {
    title: "Interview Coordination",
    description:
      "We assist with communication and coordination between candidates and schools, helping the interview process run smoothly.",
    tagline: "Coordinated communication between school and candidate.",
    icon: "CalendarCheck",
  },
  {
    title: "Ongoing Recruitment Support",
    description:
      "Mithra Jobs is positioned as a recruitment partner for schools with continuing staffing requirements, supporting you as your needs evolve.",
    tagline: "A recruitment partner for the long term.",
    icon: "Handshake",
  },
];

export const BENEFITS = [
  {
    title: "Understand the Requirement",
    description: "We begin by understanding the school's role, subject, experience and staffing requirements.",
  },
  {
    title: "Source Suitable Candidates",
    description: "We focus on identifying candidates whose experience and profile align with the requirement.",
  },
  {
    title: "Screen & Shortlist",
    description: "Candidates are reviewed before being presented to the school.",
  },
  {
    title: "Support the Hiring Process",
    description: "We help make communication and coordination between schools and candidates easier.",
  },
];

export const PROCESS_STEPS = [
  { title: "Share Your Requirement", description: "Tell us about the role, subject and experience you need." },
  { title: "Candidate Search", description: "We identify candidates who align with your requirement." },
  { title: "Screening & Shortlisting", description: "Profiles are reviewed and shortlisted for your consideration." },
  { title: "Interview Coordination", description: "We help coordinate communication between you and candidates." },
  { title: "Selection", description: "You review shortlisted candidates and make your selection." },
];

export const CATEGORIES = [
  "Schools",
  "CBSE Schools",
  "ICSE Schools",
  "International Schools",
  "Matriculation Schools",
  "Private Educational Institutions",
];

export const CLIENT_LOGOS = [
  { name: "Laxmi Global School", file: "/clients/lis.png" },
  { name: "L P Savani School", file: "/clients/lp-savani.png" },
  { name: "Millennium School", file: "/clients/millennium.jpg" },
  { name: "EuroKids", file: "/clients/eurokids.png" },
  { name: "Swarnaleela", file: "/clients/swarnleela.png" },
  { name: "St. Mary's School", file: "/clients/st-mary.gif" },
  { name: "Venkateshwara", file: "/clients/venkateshwara.jpg" },
  { name: "Mahesh PU College", file: "/clients/mahesh-pu-college.png" },
  { name: "KLE Society", file: "/clients/kle.png" },
  { name: "Tungal Schools", file: "/clients/tungal.jpg" },
  { name: "Delhi Public School International", file: "/clients/dps-international.png" },
  { name: "Radiant School", file: "/clients/radiant.jpg" },
  { name: "SR Group of Institutions", file: "/clients/sr-group.png" },
  { name: "Impulse Academy", file: "/clients/impulse-academy.jpg" },
  { name: "Jain International", file: "/clients/jain-international.jpg" },
  { name: "Suyash Gurukul", file: "/clients/suyash-gurukul.jpg" },
  { name: "Reach Academy", file: "/clients/reach-academy.jpg" },
  { name: "Sri Medha Educational Trust", file: "/clients/srimedha.png" },
  { name: "Kennedy High School", file: "/clients/kennedy-hyd.jpg" },
  { name: "Manchester International School", file: "/clients/manchester.jpg" },
  { name: "Vidyaniketan PU Science College", file: "/clients/vidhyaniketan.jpg" },
  { name: "Saraswathi School", file: "/clients/saraswathi.jpg" },
  { name: "Zee Schools", file: "/clients/zee-schools.png" },
  { name: "P Obul Reddy Public School", file: "/clients/p-obul-reddy-school.jpg" },
  { name: "Walchand College of Arts & Science", file: "/clients/walchand.jpg" },
];

export const VALUES = [
  {
    title: "Trust",
    description: "Built through consistent, honest communication with every school and candidate we work with.",
    icon: "ShieldCheck",
  },
  {
    title: "Quality",
    description: "A careful approach to understanding requirements and identifying suitable candidates.",
    icon: "Sparkle",
  },
  {
    title: "Understanding",
    description: "Every school is different, and we take the time to understand what each one needs.",
    icon: "ChatCircleText",
  },
  {
    title: "Long-Term Relationships",
    description: "We aim to be a recruitment partner schools can return to as their staffing needs evolve.",
    icon: "UsersThree",
  },
];
